import styled, { css } from "styled-components";

import {
  fadeInAndSpringAnimation,
  fadeUpAnimation,
} from "@sellernote/shipda-kr/src/components/landing/index.styles";
import { mobile } from "@sellernote/ui/src/styles/functions";

const containerWrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const container = styled.div`
  width: 1128px;
  display: flex;
  gap: 176px;

  ${mobile(css`
    width: 100%;
    padding: 48px 0px 0px 0px;
    height: auto;
    flex-direction: column;
    gap: 0;
  `)};

  ${fadeUpAnimation};
  ${fadeInAndSpringAnimation};
`;

const contentsContainer = styled.div`
  width: 548px;
  padding: 80px 0;

  ${mobile(css`
    width: 100%;
    padding: 0 16px;
  `)};

  > .chip {
    margin-bottom: 16px;
    animation-delay: 0.1s;

    ${mobile(css`
      margin-bottom: 16px;
      animation-delay: 0.2s;
    `)};
  }

  > h3 {
    animation-delay: 0.4s;
  }

  > p {
    animation-delay: 0.7s;

    ${mobile(css`
      animation-delay: 0.6s;
    `)};
  }

  > h3,
  > p {
    margin-left: 8px;
  }
`;

const imageScrollableWrapper = styled.div`
  width: 100%;
`;

const imageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;

  ${mobile(css`
    padding: 0;
    width: "100%";
  `)};

  & {
    animation-delay: 0.2s;

    ${mobile(css`
      animation-delay: 0.8s;
    `)};
  }
`;

export default {
  containerWrapper,
  container,
  contentsContainer,
  imageScrollableWrapper,
  imageWrapper,
};
